import { render, staticRenderFns } from "./Study_plan_requests.vue?vue&type=template&id=09605a92"
import script from "./Study_plan_requests.vue?vue&type=script&lang=js"
export * from "./Study_plan_requests.vue?vue&type=script&lang=js"
import style0 from "./Study_plan_requests.vue?vue&type=style&index=0&id=09605a92&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports